import { IMAGE_DIALOG_TYPES } from '../constants';

export const IMAGE_DIALOG_TITLES = {
  [IMAGE_DIALOG_TYPES.LOGO]: 'Logo',
  [IMAGE_DIALOG_TYPES.PHOTOS]: 'Photos',
};

export const ADD_IMAGE_TEXT = {
  [IMAGE_DIALOG_TYPES.LOGO]: 'Add Logo',
  [IMAGE_DIALOG_TYPES.PHOTOS]: 'Add Photos',
};

export const IMAGE_DIALOG_SUBTITLES = {
  [IMAGE_DIALOG_TYPES.LOGO]: `Manage your property's logo (SVG, PNG, JPG, - max. 10MB). Click photos to enlarge.`,
  [IMAGE_DIALOG_TYPES.PHOTOS]: `Manage your property's photos (SVG, PNG, JPG, GIF - max. 10MB). Click photos to enlarge.`,
};

export const DIALOG_CARD_LABELS = {
  CURRENT: 'current image',
  DROP_CARD_FULL_WIDTH: 'image drop area full width',
  DROP_CARD: 'image drop area',
  QUEUE: 'upload queue image',
  VALIDATION_ERROR: 'file validation error',
};

export const ACCEPTED_FILE_FORMATS = {
  [IMAGE_DIALOG_TYPES.LOGO]: [
    'image/gif',
    'image/jpeg',
    'image/png',
    'image/svg+xml',
  ],
  [IMAGE_DIALOG_TYPES.PHOTOS]: [
    'image/gif',
    'image/jpeg',
    'image/png',
    'image/svg+xml',
  ],
};
export const PHOTO_UPLOAD_KEYS = {
  [IMAGE_DIALOG_TYPES.LOGO]: 'community-logo',
  [IMAGE_DIALOG_TYPES.PHOTOS]: 'community',
};

export const MAX_IMAGE_FILE_SIZE_MB = {
  [IMAGE_DIALOG_TYPES.LOGO]: 10,
  [IMAGE_DIALOG_TYPES.PHOTOS]: 10,
};

export const MAX_IMAGE_COUNT = {
  [IMAGE_DIALOG_TYPES.LOGO]: 1,
  [IMAGE_DIALOG_TYPES.PHOTOS]: 24,
};

export const UPLOAD_STATUS = {
  CANCELING: 'canceling',
  COMPLETE: 'complete',
  FAILURE: 'failed',
  READY: 'ready',
  UPLOADING: 'uploading',
};
